import { alpha, Box, ButtonBase, ButtonBaseProps, Stack, StackProps, styled, Typography } from "@mui/material";
import Placeholder from "@Resources/game/backgrounds/3.jpg";

export const PlaylistCardButtonBase = styled((props: ButtonBaseProps) => <ButtonBase disableRipple {...props} />)(({ theme, disabled }) => ({
  display: "block",
  position: "relative",
  "&:hover": {
    "& #backgroundImage": {
      transform: "scale(1.05)",
    },
  },
}));

interface IPlaylistCardGlossWrapper {
  height: number | string;
  width: number | string;
}

export const PlaylistCardGlossWrapper = styled(Box)<IPlaylistCardGlossWrapper>(({}) => ({
  position: "relative",
  transition: `transform 0.5s cubic-bezier(0.18, 0.9, 0.58, 1)`,
}));

export const PlaylistCardImage = styled(Box)<{ disabled?: boolean; imageUrl?: string }>(({ theme, disabled, imageUrl }) => ({
  width: "100%",
  height: "100%",
  backgroundImage: `url(${imageUrl || Placeholder})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  transform: "scale(1)",
  transition: `transform 0.5s cubic-bezier(0.18, 0.9, 0.58, 1)`,
}));

export const PlaylistCardBlur = styled(Box)(({}) => ({
  position: "absolute",
  inset: 0,
  backdropFilter: "blur(4px)",
  background: "rgba(18, 19, 22, 0.20)",
}));

/**
 * @param color - Color in the form of a hexadecimal value (important)
 */
export const PlaylistCardIconWrapper = styled(Stack)<{ color?: string }>(({ color }) => ({
  background: color ? `${color}60` : "rgba(32, 33, 36, 0.60)",
  height: "100%",
  justifyContent: "center",
  alignItems: "center",
  boxSizing: "border-box",
}));

export const PlaylistCardTopRight = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(2),
  right: theme.spacing(2),
}));

export const InfoTag = styled((props: StackProps) => <Stack spacing={0.75} direction="row" {...props} />)(({ theme }) => ({
  backgroundFilter: "blur(12px)",
  backgroundColor: theme.palette.dsBase.v100,
  padding: theme.spacing(1, 1.25),
}));

export const NotPublishedTag = styled(Box)(({ theme }) => ({
  position: "absolute",
  backgroundColor: "rgba(254, 74, 74, 0.851)",
  padding: theme.spacing(1.25, 0),
  width: "100%",
  color: "white",
  bottom: 0,
  left: 0,
}));

export const BetaTag = styled(NotPublishedTag)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.dsPrimary.v300, 0.85),
}));

export const PlaylistCardLargeRoot = styled(Box)<{ imageUrl?: string | null }>(({ imageUrl }) => ({
  position: "relative",
  height: "100%",
  isolation: "isolate",
  backgroundImage: `url(${imageUrl || Placeholder})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
}));

export const PlaylistCardLargeContentWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  padding: theme.spacing(15, 6),
  zIndex: 100,
}));

export const PlaylistCardLargeLeftContent = styled(Stack)(({ theme }) => ({
  maxWidth: theme.spacing(90),
}));

interface PlaylistDescriptionStackProps extends StackProps {
  disabled?: boolean;
}

export const PlaylistDescriptionStack = styled(Stack)<PlaylistDescriptionStackProps>(({ theme, disabled }) => ({
  marginTop: theme.spacing(2),
  textAlign: "left",
  flexGrow: 1,
  opacity: disabled ? 0.3 : 1,
}));

export const PlaylistCardTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
}));

export const PlaylistCardDescription = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(7),
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
}));
